module.exports = __webpack_public_path__ + "static/media/heatleys.6f5baa7a.svg";